import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const HtmlSection = memo(({ theme, sectionId }) => {
  const HTMLSectionLayout = dynamic(() => import(/* webpackChunkName: 'HTMLSectionLayout' */ `../../../../../containers/home-page/views/sections/html/layouts/${theme.layout}`))

  return (
    <HTMLSectionLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

HtmlSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default HtmlSection
